export enum BottomDrawerMessages {
  EMPTY_STACK_MESSAGE = "Looks like you haven't added any Focus Areas yet. Start adding focus areas to see them here",
}
